import Cookies from "universal-cookie";
import _, { debounce } from "lodash";
import { STATUS_INACTIVE } from "../constants/status";


export interface IProfile {
    userId: number,
    email: string,
    mobilePhone: string,
    roleId: number,
    roleName: string,
    firstname: string,
    lastname: string
}

export const setPolicyCookie = (value: string) => localStorage.setItem("POLICY_COOKIE", value)
export const getPolicyCookie = () => localStorage.getItem("POLICY_COOKIE")

export const getToken = () => localStorage.getItem("TOKEN");

export const getRefreshToken = () => localStorage.getItem("REFRESH_TOKEN");

export const setToken = (value: string) => localStorage.setItem("TOKEN", value);

export const setRefreshToken = (token: string) => localStorage.setItem("REFRESH_TOKEN", token);

export const setOTPType = (value: any) => localStorage.setItem("OTP", value)

export const getOTPType = () => localStorage.getItem("OTP");

export const removeOTPREFER = () => localStorage.removeItem("OTPREFER");

export const setProfile = (value: any) => localStorage.setItem("PROFILE", JSON.stringify(value));

export const getLanguage = () => localStorage.getItem("language");

export const getProfile = (): any | IProfile => {
    const profile = localStorage.getItem("PROFILE");
    if (profile) {
        return JSON.parse(profile);
    }
    return null;
}


export const logout = (): void => {
    localStorage.removeItem("TOKEN");
    localStorage.removeItem("OTPREFER");
    localStorage.removeItem("REFRESH_TOKEN");
    localStorage.removeItem("PROFILE");
    localStorage.removeItem('DATE_TOKEN_EXPIRED');
    const cookies = new Cookies();
    cookies.remove("TOKEN");
    cookies.remove("PROFILE");
    cookies.remove("REFRESHTOKEN");
    cookies.remove("REFRESH_TOKEN");
};


export const getTokenPromise = () => {
    return new Promise((resolve, reject) => {
        try {
            const token = localStorage.getItem('TOKEN');
            if (token) {
                resolve(token);
            } else {
                reject(new Error('Token not found'));
            }
        } catch (error) {
            reject(error);
        }
    });
};

export const convertDate = (inputDate: string) => {
    const parts = inputDate.split('/');
    if (parts.length !== 3) {
        return null;
    }
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    const date = new Date(year, month - 1, day);
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

    return formattedDate;
}


export const ValidateTypeFile = (fileName: string, otherType?: string | undefined) => {
    const allowedExtensions = [".pdf", ".png", ".jpg", ".jpeg", otherType];
    const extension = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
    return allowedExtensions.includes(extension);
}


// set  , int number

type numberProps = {
    number: string;
    setValue: (value: string) => void
}
export const ConvertString = (props: numberProps) => {
    const rawValue = props.number.replace(/[^0-9]/g, '');
    const formattedValue = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    props.setValue(formattedValue.toString());
};

export const formattedNumber = (number: number) => {
    return number.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// set timeout search
interface searchProps {
    searchItem: string;
    setItem: (value: string) => void;
}
export const debouncedApiCall = debounce((props: searchProps) => {
    props.setItem(props.searchItem);
}, 400);

// กรองให้เหลือเฉพาะรายการที่เปิดใช้งาน แต่คงรายการที่เลือกไว้แล้ว (ข้อมูลเดิมที่ภายหลังถูกปิดใช้งาน)
export const filterActiveOptions = (options: any[] | undefined, statusKey: string, idKey: string, selectedIds: any[] = []) => {
    return (options || []).filter((option: any) => option?.[statusKey] !== STATUS_INACTIVE || selectedIds.includes(option?.[idKey]))
}


//=====================PRICE======================

// TYPE ONLY 0-9
export const handleTypingNumber = (even: any) => {
    if (!/[0-9.]/.test(even.key)) {
        even.preventDefault();
    }
}

export const handleTypingPrice = (value: any) => {
    const inputValue = value
    const validatedValue = inputValue.replace(/[^0-9.]/g, '')
    const dotCount = validatedValue.split('.').length - 1
    const decimalRegex = /^(\d*\.\d{0,2}|\d+)$/;
    if (!decimalRegex.test(validatedValue)) {
        return;
    }
    else if (dotCount > 1) {
        return;
    } else {
        return validatedValue
    }

}

export const formatNumber = (n: any) => {
    return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};


// ------------------------------ price ------------------------------

// ใช้สำหรับจัด format   excemple : 30000 -> 3,0000.00  -> ใช้ตอน onChange ครอบ value
export const formatCurrency = (value: any, blur?: any) => {
    if (value === '') {
        return '';
    }
    let inputVal = value;
    if (inputVal.indexOf('.') >= 0) {
        const decimalPos = inputVal.indexOf('.');
        const leftSide = inputVal.substring(0, decimalPos);
        const rightSide = inputVal.substring(decimalPos);

        inputVal = formatNumber(leftSide);

        if (blur === 'blur') {
            inputVal += '00';
        }

        inputVal = `${inputVal}.${formatNumber(rightSide).substring(0, 2)}`;
    } else {
        inputVal = formatNumber(inputVal);

        if (blur === 'blur') {
            inputVal += '.00';
        }
    }

    return inputVal;
};

// แปลงเป็น number ตอนส่งไป api
export const revertFormatCurrency = (value: string) => {
    const numberRevert = value.replaceAll(',', '')
    return Number(numberRevert)
}

// แปลง format จาก api   excemple : 30000.0000 -> 30,000.00
export const formatValuePrice = (value: string): string => {
    // Remove any commas and format the value with 2 decimal places
    const numericValue = parseFloat(value.replace(/,/g, ''));
    return numericValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};



// ------------------------------------------------------------------





export const formatBudgetFormApi = (value: string) => {
    if (value === '') {
        return '';
    }
    const [integerPart, decimalPart] = value.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formattedDecimal = decimalPart ? `.${decimalPart.substring(0, 2)}` : '';

    return `${formattedInteger}${formattedDecimal}`;
};





// PRICE FUNCTION
export const formatCurrencyData = (value: string, mode: 'input' | 'convert' | 'revert', blur?: any): string | number => {
    if (!value.trim()) return '';
    switch (mode) {
        case 'input':
            if (value === '') {
                return '';
            }
            let inputVal = value;
            if (inputVal.indexOf('.') >= 0) {
                const decimalPos = inputVal.indexOf('.');
                const leftSide = inputVal.substring(0, decimalPos);
                const rightSide = inputVal.substring(decimalPos);

                inputVal = formatNumber(leftSide);

                if (blur === 'blur') {
                    inputVal += '00';
                }

                inputVal = `${inputVal}.${formatNumber(rightSide).substring(0, 2)}`;
            } else {
                inputVal = formatNumber(inputVal);

                if (blur === 'blur') {
                    inputVal += '.00';
                }
            }
            return inputVal;

        case 'convert':
            const numberRevert = value.replaceAll(',', '')
            return Number(numberRevert)

        case 'revert':
            const numericValue = parseFloat(value.replace(/,/g, ''));
            return numericValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        default:
            return value;
    }
};


export const handleTypingLatitudeNumber = (e: any) => {
    // Allow only numbers and '.' (decimal point)
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
    }
};

export const formatPhoneNumberTh = (phoneNumber: string) => {
    if (!phoneNumber) return phoneNumber
    const phoneNum = phoneNumber.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNum.length;
    if (phoneNumberLength < 4) return phoneNum
    if (phoneNumberLength < 7) {
        return `${phoneNum.slice(0, 3)} ${phoneNum.slice(3)}`
    }
    return `${phoneNum.slice(0, 3)}-${phoneNumber.slice(
        3,
        6
    )}-${phoneNum.slice(6, 10)}`
}


export const typingPrice = (budget: number, digit?: number): string => {
    if (isNaN(+budget) || typeof (budget) !== 'number') {
        return ""
    }
    let price: string = budget.toLocaleString(undefined, { minimumFractionDigits: digit })
    return price
}